import { FeatureCardComponent } from "./FeatureCardComponent";
import telefonoSvg from "../../../assets/svgFeatures/Telefono.svg";
import mathSvg from "../../../assets/svgFeatures/Math.svg";
import otherSvg from "../../../assets/svgFeatures/Others.svg";

export const FeaturesComponent = () => {
  return (
    <section id="Features" className="features section">
      <div className="container">
        <div className="features-inner section-inner">
          <div className="features-header text-center">
            <div className="container-sm">
              <h2 className="section-title mt-0">Catálogo de proyectos</h2>
              <p className="section-paragraph">
                Contamos con varios catálogos de proyectos que se adaptan a las necesidades del negocio.
              </p>
            </div>
          </div>
          <div className="features-wrap">
            <FeatureCardComponent
              title="e-Vet"
              description="Sitema enfocado la salud de nuestras mascotas, permite integrar al negocio el manejo de expedientes y seguimiento con tús clientes."
              backgroundColor="#FFD2DA"
            />
            <FeatureCardComponent
              title="e-Nutrición"
              description="Sistema dedicado para el manejo de expedientes nutricionales, donde los clientes puedan llevar el control de los avances y resultados."
              backgroundColor="#FFD8CD"
            />
            {/* <FeatureCardComponent
              title="Desarrollo web"
              description="A pseudo-Latin text used in web design, layout, and printing in place of English to emphasise design elements."
              backgroundColor="#C6FDF3"
              svg={mathSvg}
            />
            <FeatureCardComponent
              title="Otros"
              description="A pseudo-Latin text used in web design, layout, and printing in place of English to emphasise design elements."
              backgroundColor="#E0E1FE"
              svg={otherSvg}
            /> */}
          </div>
        </div>
      </div>
    </section>
  );
};
